'use client';

import { Text } from '@/shared/ui';
import { formatArticleDate } from '@/shared/utils/formatArticleDate';

import styles from './Article.module.css';

export const ArticleDate = ({ date }: { date: string }) => {
  return (
    <Text
      className={styles.date}
      fontSize={12}
      fontWeight={600}
      lineHeight="140%"
      letterSpacing={0.024}
      color="neutral-4-100"
    >
      {formatArticleDate(date ?? '')}
    </Text>
  );
};
